import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsChipModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsPortalModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { CmpsMi2TableModule } from '../table';

import { MainComponent } from './main.component';
import { TranslationIdMap } from './main.i18n';

@NgModule({
    declarations: [MainComponent],
    exports: [MainComponent],
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsChipModule,
        CmpsButtonModule,
        CmpsFilterModule,
        CmpsPortalModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsMi2TableModule,
    ],
})
export class CmpsMi2MainModule {}
